/* Verhuisd uit sections/single-product.liquid: stond als inline script in het
   document (parse vóór de eerste paint). Liquid-waarden komen uit window.FLORAFY_PDP,
   gezet door de sectie vlak vóór deze scripts. */
var cfg = window.FLORAFY_PDP || {};
/**
 * Custom scroll progress bar for pot configurator (iOS compatible)
 */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const slider = document.querySelector('.js-oppot-slider');
    const track = document.querySelector('.scroll-progress-track');
    const thumb = document.querySelector('.scroll-progress-thumb');

    if (!slider || !track || !thumb) return;

    // Layout lezen (scrollWidth/clientWidth) dwingt een layout af zodra een
    // ander script de pagina net heeft gewijzigd; tijdens het laden kreeg dit
    // script zo de rekening van de hele pagina (tot 260 ms in het CPU-profiel).
    // Daarom meten we maten via ResizeObserver of in de animation frame na een
    // kaartwijziging. Scrollen leest alleen scrollLeft en gebruikt deze cache.
    var clientWidth = 0;
    var scrollWidth = 0;
    var trackVisible = null;

    function setTrackVisible(visible) {
      if (trackVisible === visible) return;
      trackVisible = visible;
      track.style.display = visible ? '' : 'none';
    }

    function paint() {
      var maxScroll = scrollWidth - clientWidth;
      if (maxScroll <= 0) {
        setTrackVisible(false);
        return;
      }
      var scrollPercent = slider.scrollLeft / maxScroll;
      var thumbWidth = Math.max(20, (clientWidth / scrollWidth) * 100);
      setTrackVisible(true);
      thumb.style.width = thumbWidth + '%';
      thumb.style.left = scrollPercent * (100 - thumbWidth) + '%';
    }

    function measure() {
      clientWidth = slider.clientWidth;
      scrollWidth = slider.scrollWidth;
      paint();
    }

    var framePending = false;
    var measureBeforePaint = false;

    function schedulePaint(needsMeasurement) {
      measureBeforePaint = measureBeforePaint || needsMeasurement;
      if (framePending) return;
      framePending = true;
      requestAnimationFrame(function () {
        framePending = false;
        if (measureBeforePaint) {
          measureBeforePaint = false;
          measure();
          return;
        }
        paint();
      });
    }

    slider.addEventListener('scroll', function () {
      schedulePaint(false);
    }, { passive: true });

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        schedulePaint(true);
      }).observe(slider, { childList: true });
    }

    if ('ResizeObserver' in window) {
      // Vuurt ook meteen na observe(), dus dit is tevens de eerste meting.
      new ResizeObserver(measure).observe(slider);
    } else {
      window.addEventListener('load', measure, { once: true });
      window.addEventListener('resize', measure);
    }
  });
})();
